import Cookies from "js-cookie";
import requestApi from "../client/EntityApi";
import CrudTable from "../core/component/crud/CrudTable";
import {
  getPetCPColumns,
  getPetCPExpandedRowRender,
} from "../components/crud/PetCPComponents";
import { useState } from "react";

const ReportPage = () => {
  const [constants, setConstants] = useState<any>();

  const getAll = () => {
    const key = Cookies.get("key");
    const psw = Cookies.get("psw");
    return key && psw
      ? requestApi.getPetCover(key, psw, "pets")
      : new Promise((resolve, reject) => {
          resolve([]);
          reject();
        });
  };

  const getConstants = () => {
    const key = Cookies.get("key");
    const psw = Cookies.get("psw");
    if (key && psw) {
      requestApi
        .getPetCover(key, psw, "constants")
        .then((response: any) => setConstants(response));
    }
  };

  return (
    <CrudTable
      entityLabel="Pet"
      searchKeys={["name", "chipNo", "passportNo"]}
      api={{}}
      getAll={getAll}
      columns={getPetCPColumns(constants?.genus)}
      hideAddProcess
      hideDefaultRowProceses
      afterRefreshOperation={() => getConstants()}
      expandable={{
        expandedRowRender: (record) =>
          getPetCPExpandedRowRender(record, constants?.vaccineStatus),
      }}
    />
  );
};

export default ReportPage;
